import { render, staticRenderFns } from "./docnodeapproval.vue?vue&type=template&id=40f765cb&scoped=true&"
import script from "./docnodeapproval.vue?vue&type=script&lang=js&"
export * from "./docnodeapproval.vue?vue&type=script&lang=js&"
import style0 from "./docnodeapproval.vue?vue&type=style&index=0&id=40f765cb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f765cb",
  null
  
)

export default component.exports